export default __webpack_public_path__ + "static/media/logo-dark.afbb5d34.svg";